/** Full persistent sidebar starts here (matches page-wrapper margin in layout CSS). */
export const SIDEBAR_DESKTOP_MIN_WIDTH = 1024;
